import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Typography,
} from '@mui/material';

interface CfopSelectProps {
  value?: string | null;
  onChange: (value: string | null) => void;
  label?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  allowClear?: boolean;
}

const CFOP_LABELS: Record<string, string> = {
  '5301': '5301 - fornecimento outro provedor ou cidade digital',
  '5302': '5302 - Prestação de serviço de comunicação a estabelecimento industrial',
  '5303': '5303 - Prestação de serviço de comunicação a estabelecimento comercial',
  '5304': '5304 - Prestação de serviço de comunicação a estabelecimento de prestador de serviço de transporte',
  '5305': '5305 - Prestação de serviço de comunicação a estabelecimento de geradora ou de distribuidora de energia elétrica',
  '5306': '5306 - Prestação de serviço de comunicação a estabelecimento de produtor rural',
  '5307': '5307 - Prestação de serviço de comunicação a não-contribuinte',
  '6301': '6301 - fornecimento outro provedor ou cidade digital',
  '6302': '6302 - Prestação de serviço de comunicação a estabelecimento industrial',
  '6303': '6303 - Prestação de serviço de comunicação a estabelecimento comercial',
  '6304': '6304 - Prestação de serviço de comunicação a estabelecimento de prestador de serviço de transporte',
  '6305': '6305 - Prestação de serviço de comunicação a estabelecimento de geradora ou de distribuidora de energia elétrica',
  '6306': '6306 - Prestação de serviço de comunicação a estabelecimento de produtor rural',
  '6307': '6307 - Prestação de serviço de comunicação a não-contribuinte',
};

const CfopSelect: React.FC<CfopSelectProps> = ({
  value = '',
  onChange,
  label = 'CFOP',
  placeholder = 'Selecione um CFOP',
  required = false,
  disabled = false,
  error = false,
  helperText,
  size = 'small',
  fullWidth = true,
  allowClear = true,
}) => {
  const handleChange = (event: any) => {
    const v = event.target.value;
    onChange(v === '' ? null : String(v));
  };

  return (
    <FormControl
      fullWidth={fullWidth}
      size={size}
      error={error}
      disabled={disabled}
      required={required}
      variant="outlined"
    >
      <InputLabel>{label}</InputLabel>
      <Select
        value={value ?? ''}
        onChange={handleChange}
        label={label}
        displayEmpty
        renderValue={(selected: any) => {
          if (selected === '' || selected == null) {
            return <em>{placeholder}</em>;
          }
          return CFOP_LABELS[String(selected)] ?? selected;
        }}
      >
        {allowClear && (
          <MenuItem value="">
            <em>{placeholder}</em>
          </MenuItem>
        )}

        {/* PRESTAÇÕES DE SERVIÇOS DE COMUNICAÇÃO DENTRO DO PRÓPRIO ESTADO DO PROVEDOR */}
        <MenuItem disabled>
          <Typography variant="body2" fontWeight="bold" color="primary">
            PRESTAÇÕES DE SERVIÇOS DE COMUNICAÇÃO DENTRO DO PRÓPRIO ESTADO DO PROVEDOR
          </Typography>
        </MenuItem>
        <MenuItem value="5301">5301 - fornecimento outro provedor ou cidade digital</MenuItem>
        <MenuItem value="5302">5302 - Prestação de serviço de comunicação a estabelecimento industrial</MenuItem>
        <MenuItem value="5303">5303 - Prestação de serviço de comunicação a estabelecimento comercial</MenuItem>
        <MenuItem value="5304">5304 - Prestação de serviço de comunicação a estabelecimento de prestador de serviço de transporte</MenuItem>
        <MenuItem value="5305">5305 - Prestação de serviço de comunicação a estabelecimento de geradora ou de distribuidora de energia elétrica</MenuItem>
        <MenuItem value="5306">5306 - Prestação de serviço de comunicação a estabelecimento de produtor rural</MenuItem>
        <MenuItem value="5307">5307 - Prestação de serviço de comunicação a não-contribuinte</MenuItem>

        {/* PRESTAÇÕES DE SERVIÇOS DE COMUNICAÇÃO PARA CLIENTES FORA DO ESTADO DO PROVEDOR */}
        <MenuItem disabled>
          <Typography variant="body2" fontWeight="bold" color="primary" sx={{ mt: 1 }}>
            PRESTAÇÕES DE SERVIÇOS DE COMUNICAÇÃO PARA CLIENTES FORA DO ESTADO DO PROVEDOR
          </Typography>
        </MenuItem>
        <MenuItem value="6301">6301 - fornecimento outro provedor ou cidade digital</MenuItem>
        <MenuItem value="6302">6302 - Prestação de serviço de comunicação a estabelecimento industrial</MenuItem>
        <MenuItem value="6303">6303 - Prestação de serviço de comunicação a estabelecimento comercial</MenuItem>
        <MenuItem value="6304">6304 - Prestação de serviço de comunicação a estabelecimento de prestador de serviço de transporte</MenuItem>
        <MenuItem value="6305">6305 - Prestação de serviço de comunicação a estabelecimento de geradora ou de distribuidora de energia elétrica</MenuItem>
        <MenuItem value="6306">6306 - Prestação de serviço de comunicação a estabelecimento de produtor rural</MenuItem>
        <MenuItem value="6307">6307 - Prestação de serviço de comunicação a não-contribuinte</MenuItem>

        {/* OUTROS */}
        <MenuItem disabled>
          <Typography variant="body2" fontWeight="bold" color="primary" sx={{ mt: 1 }}>
            OUTROS
          </Typography>
        </MenuItem>
        {allowClear && (
          <MenuItem value="">Nenhum</MenuItem>
        )}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default CfopSelect;
